export const getColor =(index) => {
    const flatColors = [
        "#FF6B6B", // Coral Red
        "#4ECDC4", // Turquoise
        "#45B7D1", // Sky Blue
        "#F7B801", // Mustard Yellow
        "#5C7CFA", // Indigo Blue
     
        "#FF922B", // Orange
        "#20C997", // Mint Green
        "#E64980", // Pink
        "#7950F2", // Purple
        "#228BE6", // Ocean Blue
     
        "#40C057", // Green
        "#FA5252", // Flat Red
        "#BE4BDB", // Violet
        "#12B886", // Teal
        "#FAB005", // Amber
     
        "#15AABF", // Cyan
        "#FD7E14", // Dark Orange
        "#845EF7", // Lavender
        "#51CF66", // Lime Green
        "#339AF0", // Blue
     
        "#FF8787", // Soft Red
        "#63E6BE", // Aqua Green
        "#748FFC", // Soft Indigo
        "#FFD43B", // Bright Yellow
        "#9775FA", // Soft Purple
     
        "#38D9A9", // Sea Green
        "#FF6F91", // Rose Pink
        "#3BC9DB", // Bright Cyan
        "#FCC419", // Gold
        "#74C0FC", // Light Blue
     
        "#F06595", // Magenta Pink
        "#66D9E8", // Ice Blue
        "#69DB7C", // Fresh Green
        "#B197FC", // Light Violet
        "#FFA94D", // Peach Orange
     
        "#A9E34B", // Neon Green
        "#FF8787", // Salmon
        "#4DABF7", // Azure
        "#DA77F2", // Orchid
        "#FFD8A8", // Cream Orange
     
        "#63E6BE", // Mint
        "#C0EB75", // Lime
        "#91A7FF", // Periwinkle
        "#FFEC99", // Pale Yellow
        "#FAA2C1", // Soft Pink
     
        "#99E9F2", // Pale Cyan
        "#8CE99A", // Pale Green
        "#D0BFFF", // Pale Purple
        "#FFC078", // Light Orange
        "#ADB5BD"  // Cool Gray
      ];
    return flatColors[index % flatColors.length];
}